// extracted by mini-css-extract-plugin
module.exports = {"inviteButton":"_2fKQM0"};